import { returnToVendor as returnToVendorEn } from '../en/returnToVendor';

export const returnToVendor = {
  ...returnToVendorEn,
  returnToVendors: 'සැපයුම්කරුට ආපසු භාණ්ඩ',
  allReturnToVendors: 'සියලුම සැපයුම්කරුට ආපසු භාණ්ඩ',
  createReturnToVendor: 'සැපයුම්කරුට ආපසු භාණ්ඩයක් සාදන්න',
  returnToVendorDetails: 'සැපයුම්කරුට ආපසු භාණ්ඩයේ විස්තර',
  status_completed: 'සම්පූර්ණයි',
  status_voided: 'අවලංගු කරන ලදී',
  viewAndManageAllReturnToVendors: "සැපයුම්කරුට ආපසු යැවූ සියලු භාණ්ඩ බලන්න සහ කළමනාකරණය කරන්න",
  createReturnToVendorDescription: "භාණ්ඩ ලැබුණු සටහනකට එරෙහිව ලැබුණු අයිතම සැපයුම්කරුට ආපසු යවන්න",
  rtvNumber: "RTV අංකය",
  purchaseOrderNumber: "මිලදී ගැනීමේ ඇණවුම",
  grnNumber: "GRN අංකය",
  supplier: "සැපයුම්කරු",
  totalDebitAmount: "මුළු ණය මුදල",
  createdAt: "සාදන ලද දිනය",
  createdBy: "සෑදුවේ",
  status: "තත්ත්වය",
  actions: "ක්‍රියා",
  item: "අයිතමය",
  warehouse: "ගබඩාව",
  details: "ආපසු යැවීමේ විස්තර",
  itemsToReturn: "ආපසු යැවිය යුතු අයිතම",
  itemsReturned: "ආපසු යැවූ අයිතම",
  returnableQuantity: "ආපසු යැවිය හැකි ප්‍රමාණය",
  quantityReturned: "ආපසු යැවූ ප්‍රමාණය",
  unitPriceLabel: "ඒකක මිල",
  lineAmount: "පේළි මුදල",
  unitsSelected: "ඒකක තෝරා ඇත",
  linkedDebitNotes: "සම්බන්ධිත ණය සටහන්",
  lookupGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන සොයන්න",
  goodsReceivedNoteIdPlaceholder: "භාණ්ඩ ලැබුණු සටහන තෝරන්න",
  purchaseOrderIdPlaceholder: "මිලදී ගැනීමේ ඇණවුම් ID හෝ අංකය ඇතුළත් කරන්න",
  grnIdPlaceholder: "GRN ID හෝ අංකය ඇතුළත් කරන්න",
  lookupButton: "සොයන්න",
  selectGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන තෝරන්න",
  multipleGoodsReceivedNotesFound: "මෙම ඇණවුම සඳහා GRN කිහිපයක් හමු විය — එකක් තෝරන්න",
  goodsReceivedNoteNotFound: "භාණ්ඩ ලැබුණු සටහන හමු නොවීය",
  purchaseOrderNotFound: "මිලදී ගැනීමේ ඇණවුම හමු නොවීය",
  reason: "හේතුව",
  reasonPlaceholder: "ආපසු යැවීමට හේතුව (විකල්ප)",
  returnFromWarehouse: "ආපසු යවන ගබඩාව",
  selectWarehouse: "ගබඩාව තෝරන්න",
  create: "සැපයුම්කරුට ආපසු යැවීම සාදන්න",
  save: "සුරකින්න",
  voidReturnToVendor: "ආපසු යැවීම අවලංගු කරන්න",
  void: "අවලංගු කරන්න",
  print: "මුද්‍රණය කරන්න",
  printReturnToVendor: "ආපසු යැවීම මුද්‍රණය කරන්න",
  backToReturnToVendors: "සැපයුම්කරුට ආපසු භාණ්ඩ වෙත ආපසු",
  confirmVoid: "මෙම ආපසු යැවීම අවලංගු කිරීමට ඔබට විශ්වාසද? තොගය යථා තත්ත්වයට පත් කෙරෙන අතර සම්බන්ධිත ණය සටහනද අවලංගු වේ.",
  voidReason: "අවලංගු කිරීමට හේතුව",
  voidReasonPlaceholder: "අවලංගු කිරීමට හේතුව ඇතුළත් කරන්න (විකල්ප)...",
  filterByPurchaseOrder: "මිලදී ගැනීමේ ඇණවුම අනුව පෙරහන් කරන්න",
  filterByGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන අනුව පෙරහන් කරන්න",
  rtvCreatedSuccessWithDebitNote: "ආපසු යැවීම {rtvNumber} සාදන ලදී — ණය සටහන {debitNoteNumber} ස්වයංක්‍රීයව නිකුත් කරන ලදී",
  rtvVoidedSuccessfully: "ආපසු යැවීම සාර්ථකව අවලංගු කරන ලදී",
  failedToCreateReturnToVendor: "ආපසු යැවීම සෑදීමට අසමත් විය",
  failedToLoadReturnToVendors: "ආපසු යැවීම් පූරණය කිරීමට අසමත් විය",
  failedToLoadReturnToVendor: "ආපසු යැවීම පූරණය කිරීමට අසමත් විය",
  failedToVoidReturnToVendor: "ආපසු යැවීම අවලංගු කිරීමට අසමත් විය",
  someFieldsRequired: "ඉදිරිපත් කිරීමට පෙර ඉස්මතු කළ ක්ෂේත්‍ර නිවැරදි කරන්න",
  goodsReceivedNoteRequired: "කරුණාකර භාණ්ඩ ලැබුණු සටහනක් තෝරන්න",
  atLeastOneItemRequired: "කරුණාකර ආපසු යැවීමට අවම වශයෙන් එක් අයිතමයක් තෝරන්න",
  unitPriceRequired: "කරුණාකර ඒකක මිලක් ඇතුළත් කරන්න",
  warehouseRequired: "කරුණාකර ගබඩාවක් තෝරන්න",
  noReturnToVendorsFound: "ආපසු යැවීම් හමු නොවීය",
  noReturnToVendorsYet: "තවමත් ආපසු යැවීම් නැත.",
  noReturnToVendorsFoundDescription: "ඔබගේ වත්මන් පෙරහන්වලට ගැළපෙන ආපසු යැවීම් නැත",
  noReturnToVendorsYetDescription: "සැපයුම්කරුවෙකුට අයිතම ආපසු යැවීමට ඔබගේ පළමු ආපසු යැවීම සාදන්න.",
  createFirstReturnToVendor: "පළමු ආපසු යැවීම සාදන්න",
  searchGoodsReceivedNote: "GRN හෝ මිලදී ගැනීමේ ඇණවුම් අංකය අනුව සොයන්න...",
  noGoodsReceivedNotesFound: "භාණ්ඩ ලැබුණු සටහන් හමු නොවීය",
  goodsReceivedNoteCancelled: "අවලංගු කළ භාණ්ඩ ලැබුණු සටහනකට එරෙහිව ආපසු යැවිය නොහැක",
  allStatuses: "සියලුම තත්ත්වයන්",
  searchPlaceholder: "RTV, PO හෝ GRN අංකයෙන් සොයන්න",
};
